import React from 'react';
import AddBookingFunctional from './components/add-booking-functional';
import './styles.scss';

const AddBooking = ({ state, setState, refreshList }) => {
	return <AddBookingFunctional {...{ state, setState, refreshList }} />;
};

export default AddBooking;
